import { canManageUsers } from '@jfh/intake-shared';
import { useMe } from './useMe.js';

/** Whether the signed-in user is an admin (shares the one /me call). */
export function useIsAdmin(): boolean {
  const me = useMe();
  return me ? canManageUsers(me.role) : false;
}
